import * as Sentry from "@sentry/react"
import { useEffect } from "react"
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom"

Sentry.init({
  dsn: "https://fc385336e9182549868602480426ea24@o4511011513368576.ingest.us.sentry.io/4511011515269120",

  environment: import.meta.env.MODE,

  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,

  beforeSend(event) {
    const url = event.request?.url ?? '';
    if (url.includes('fetchProfilePictureUrl')) return null;
    return event;
  },

  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
})
